import React from "react";
import { TextNode } from "../../types";

/**
 * Create handle block drag start
 */
export function createHandleBlockDragStart(
  textNode: TextNode,
  onBlockDragStart?: (nodeId: string) => void
) {
  return (e: React.DragEvent) => {
    e.stopPropagation();
    e.dataTransfer.effectAllowed = "move";
    e.dataTransfer.setData("text/plain", textNode.id);
    e.dataTransfer.setData(
      "application/json",
      JSON.stringify({
        nodeId: textNode.id,
        type: textNode.type,
      })
    );
    if (onBlockDragStart) {
      onBlockDragStart(textNode.id);
    }
  };
}

/**
 * Create handle block drag end
 */
export function createHandleBlockDragEnd(
  onDragEnd?: () => void
) {
  return (e: React.DragEvent) => {
    e.stopPropagation();
    // Clear dragging state
    if (onDragEnd) {
      onDragEnd();
    }
  };
}

